export default "__VITE_ASSET__DOx3D9Xp__"